export default "__VITE_ASSET__f08a630b__"